import { Box, Heading, HStack, Select, Stack, Text } from '@chakra-ui/react';
import Newsletter from '../components/Newsletter';
import Products from '../components/Products';
import WrapContent from '../components/WrapContent';

const ProductList = () => {
  return (
    <Box>
      <WrapContent>
        <Heading as="h1" py="4" fontSize="24px">
          Products
        </Heading>
        <HStack justifyContent={'space-between'}>
          <Stack
            pt="0"
            alignItems={['flex-start', 'flex-start', 'center']}
            flexDir={['column', 'column', 'row']}
            width="fit-content"
          >
            <Text pt="1" pr="1" fontSize="xs">
              Filter :
            </Text>
            <HStack>
              <Select size="xs">
                <option disabled selected>
                  Accessories
                </option>
                <option>ipod</option>
                <option>charger</option>
                <option>earpiece</option>
                <option>mp3 player</option>
                <option>charger cord</option>
              </Select>
              <Select size="xs">
                <option disabled selected>
                  Color
                </option>
                <option>Black</option>
                <option>White</option>
                <option>Red</option>
                <option>Blue</option>
                <option>Ash</option>
              </Select>
            </HStack>
          </Stack>
          <Stack
            pt="0"
            alignItems={['flex-start', 'flex-start', 'center']}
            flexDir={['column', 'column', 'row']}
            width="fit-content"
          >
            <Text pt="1" pr="1" fontSize="xs">
              Sort :
            </Text>
            <HStack>
              <Select size="xs">
                <option selected>Newest</option>
                <option>Price(Asc)</option>
                <option>Price(Desc)</option>
              </Select>
            </HStack>
          </Stack>
        </HStack>
        <Products />
        <Newsletter />
      </WrapContent>
    </Box>
  );
};

export default ProductList;
